import React from "react";

function IconPlanAuditoria() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 16 16"
      xmlSpace="preserve"
    >
      <path
        fill="#0D6EFD"
        d="M9.031 12.894l-.37.969 1.114-.242-.744-.727zM12.7 9.041l-3.158 3.046 1.11 1.083 3.178-3.036-1.13-1.093zm0-1.098c.13 0 .256.048.358.145l1.88 1.816.015.23a.53.53 0 01-.157.371l-4.022 3.843-.146.042-2.525.55a.51.51 0 01-.503-.168l-.18-.212.093-.306.905-2.374.085-.087 3.841-3.706a.51.51 0 01.356-.144zM7.944 1.595v1.691h1.69l-1.69-1.691zM.935 0H7.67l3.545 3.545v4.866h-.935v-4.19H7.009V.935H.935v13.084h5.607v.935H.935A.937.937 0 010 14.019V.935C0 .419.419 0 .935 0z"
      ></path>
      <path
        fill="#0A58CA"
        d="M7.586 6.792c0 .354-.059.674-.176.958a2.055 2.055 0 01-.5.728 2.218 2.218 0 01-.8.465c-.316.111-.693.164-1.131.164h-.805v2.551c0 .029-.008.056-.024.077s-.042.04-.078.053a.948.948 0 01-.142.033 1.57 1.57 0 01-.227.014 1.58 1.58 0 01-.227-.014 1.033 1.033 0 01-.145-.033c-.036-.013-.062-.03-.077-.053s-.021-.048-.021-.077V5.121c0-.146.039-.25.115-.312a.402.402 0 01.257-.094h1.516c.153 0 .3.006.441.02s.307.04.498.082c.192.042.387.121.586.236.2.114.368.257.507.424.14.167.246.363.322.583.074.221.111.464.111.732zm-.991.076c0-.289-.055-.529-.161-.722-.108-.194-.241-.339-.4-.434s-.324-.155-.493-.18a3.266 3.266 0 00-.496-.039h-.871v2.842h.849c.285 0 .521-.037.709-.109.188-.072.346-.174.474-.304s.224-.285.291-.465c.066-.18.098-.377.098-.589z"
      ></path>
    </svg>
  );
}

export default IconPlanAuditoria;
